import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Reveal } from "@/components/Reveal";
import { WHATSAPP_URL, WHATSAPP_NUMBER_DISPLAY } from "@/lib/config";

export const FinalCTA = () => (
    <section
        className="relative overflow-hidden bg-brand-navy py-24 text-white sm:py-32"
        data-testid="final-cta-section"
    >
        <div
            aria-hidden="true"
            className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-brand-orange/20 blur-[130px]"
        />
        <div className="relative mx-auto max-w-3xl px-5 text-center">
            <Reveal>
                <h2 className="font-sans text-4xl font-black tracking-tight sm:text-5xl">
                    ¿Listo para <span className="text-brand-orange">empezar?</span>
                </h2>
            </Reveal>
            <Reveal delay={0.12}>
                <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-white/70 sm:text-lg">
                    Descarga la app o escríbenos directamente al{" "}
                    <span className="font-bold text-white">{WHATSAPP_NUMBER_DISPLAY}</span>.
                    Te respondemos en minutos.
                </p>
            </Reveal>
            <Reveal delay={0.22}>
                <motion.a
                    href={WHATSAPP_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="final-whatsapp-btn"
                    whileHover={{ scale: 1.05, y: -2 }}
                    whileTap={{ scale: 0.96 }}
                    className="mt-9 inline-flex items-center gap-3 rounded-full bg-brand-wa px-8 py-4 font-sans text-lg font-bold text-white shadow-2xl shadow-brand-wa/30 transition-colors duration-200 hover:bg-brand-wadark"
                >
                    <MessageCircle className="h-6 w-6" strokeWidth={2.4} />
                    Hablar por WhatsApp
                </motion.a>
            </Reveal>
        </div>
    </section>
);

export const Footer = () => (
    <footer className="border-t border-white/10 bg-brand-ink py-10 text-white" data-testid="footer">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-6 px-5 sm:flex-row sm:justify-between">
            <Logo light />
            <nav className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2" aria-label="Enlaces legales">
                <Link to="/aviso-legal" data-testid="footer-aviso-legal-link" className="font-sans text-xs text-white/60 transition-colors duration-200 hover:text-white">
                    Aviso legal
                </Link>
                <Link to="/privacidad" data-testid="footer-privacidad-link" className="font-sans text-xs text-white/60 transition-colors duration-200 hover:text-white">
                    Privacidad
                </Link>
                <Link to="/cookies" data-testid="footer-cookies-link" className="font-sans text-xs text-white/60 transition-colors duration-200 hover:text-white">
                    Cookies
                </Link>
                <Link to="/panel" data-testid="footer-panel-link" className="font-sans text-xs text-white/60 transition-colors duration-200 hover:text-white">
                    Acceso equipo
                </Link>
            </nav>
            <p className="font-sans text-xs text-white/50" data-testid="footer-copy">
                © 2026 Puertalia Portal
            </p>
        </div>
    </footer>
);
